import React from "react";
import "./Module.css";

const CourseModules = () => {
  return (
    <div className="card-body">
      <div className="course-content">
        <h2 className="course-title">Courses We Offer</h2>
        <div className="modules-container">

          <div className="module">
            <h3><span>Performance Marketing Mastery</span></h3>
            <ul>
              <li>Understand paid traffic across Meta, Google & LinkedIn</li>
              <li>Learn ad funnel creation for lead generation</li>
              <li>Hands-on with ads manager, pixel & analytics</li>
              <li>Audience research and targeting strategies</li>
              <li>Optimize campaigns for conversions & ROI</li>
            </ul>
          </div>

          <div className="module">
            <h3><span>Complete Digital Marketing Course</span></h3>
            <ul>
              <li>SEO, SEM, SMM, Email & Content Marketing</li>
              <li>Basics to advanced tools & techniques</li>
              <li>How digital marketing works in real businesses</li>
              <li>Learn to build digital strategy for brands</li>
              <li>Tools: Google Analytics, Canva, Mailchimp</li>
            </ul>
          </div>

          <div className="module">
            <h3><span>SEO Course for Beginners to Advanced</span></h3>
            <ul>
              <li>Understand On-Page & Off-Page SEO fundamentals</li>
              <li>Keyword research using tools like Ubersuggest & SEMrush</li>
              <li>Technical SEO and website optimization</li>
              <li>Local SEO, Google My Business & Maps ranking</li>
              <li>SEO tools: Google Search Console, Ahrefs, Yoast</li>
            </ul>
          </div>

          <div className="module">
            <h3><span>LinkedIn Course For B2B</span></h3>
            <ul>
              <li>Create impactful B2B LinkedIn ad campaigns</li>
              <li>Setup Company page, Campaign Manager</li>
              <li>Target decision-makers with laser precision</li>
              <li>Measure performance & budget optimization</li>
              <li>LinkedIn lead generation and outreach</li>
            </ul>
          </div>

          <div className="module">
            <h3><span>Social Media Marketing Expert Course</span></h3>
            <ul>
              <li>Organic & paid growth strategies for IG/FB</li>
              <li>Learn reel strategy, content calendar, hashtags</li>
              <li>Campaign creation on Meta Ads</li>
              <li>Social media reporting and insights</li>
              <li>Influencer & UGC collaboration tactics</li>
            </ul>
          </div>

          <div className="module">
            <h3><span>PPC & Google Ads Specialization</span></h3>
            <ul>
              <li>Create high-converting search campaigns</li>
              <li>Google keyword planner and ad groups</li>
              <li>Set up conversion tracking and remarketing</li>
              <li>Video ads, display ads, shopping ads</li>
              <li>Budgeting, bidding, and ad copywriting</li>
            </ul>
          </div>

          <div className="module">
            <h3><span>Video Editing for Social Media</span></h3>
            <ul>
              <li>Tools: CapCut, Canva, Premiere Pro Basics</li>
              <li>Create scroll-stopping reels & stories</li>
              <li>Understand hooks, storytelling & transitions</li>
              <li>Editing for Instagram, YouTube, Shorts</li>
              <li>Add subtitles, effects, music & branding</li>
            </ul>
          </div>

          <div className="module">
            <h3><span>100% Job Guarantee & Career Support</span></h3>
            <ul>
              <li>Dedicated placement assistance</li>
              <li>Mock interviews & resume building</li>
              <li>Live projects for portfolio development</li>
              <li>Internship support for freshers</li>
              <li>Get certified and job-ready in 90 days</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
};

export default CourseModules;
